import LdProfilePicture from 'lion-vue-src/Shared/components/LdProfilePicture';
export default LdProfilePicture;
